import React from 'react';
import styles from './HowXRayWorks.module.css';
import classNames from 'classnames';
import { CodingIcon } from './Icons/CodingIcon';
import { DatabaseIcon } from './Icons/DatabaseIcon';
import { BrowserIcon } from './Icons/BrowserIcon';
import { VisitorsIcon } from './Icons/VisitorsIcon';

export const HowXRayWorks = ({
  css,
  header,
  iconColor,
}: {
  css?: { container?: string; heading?: string; content?: string };
  header?: string;
  iconColor?: string;
}) => {
  return (
    <div className={classNames(styles.container, css?.container)}>
      <div className={classNames(styles.heading, css?.heading)}>
        {header || 'How it works?'}
      </div>
      <div className={classNames(styles.content, css?.content)}>
        <div className={styles.item}>
          1.You will install the script.
          <CodingIcon color={iconColor} />
        </div>
        <div className={styles.item}>
          2. Anonymous visitors land on your website.
          <DatabaseIcon color={iconColor} />
        </div>
        <div className={styles.item}>
          3. Our system checks and matches the user against our database.
          <BrowserIcon color={iconColor} />
        </div>
        <div className={styles.item}>
          4. We send you the contact information of your previously anonymous
          visitors.
          <VisitorsIcon color={iconColor} />
        </div>
      </div>
    </div>
  );
};
